import {Banner, VisuallyHidden} from '@primer/react'

import {PROJECTS_DOCS_URL, WELCOME_DESCRIPTION, WELCOME_TITLE} from './constants'
import styles from './WelcomeBanner.module.css'

interface WelcomeBannerProps {
  onDismiss: () => void
}

/**
 * Inline welcome banner shown above the project list once the welcome splash
 * has been dismissed.
 */
export function WelcomeBanner({onDismiss}: WelcomeBannerProps) {
  return (
    <Banner
      className={styles.banner}
      variant="info"
      title={WELCOME_TITLE}
      description={WELCOME_DESCRIPTION}
      onDismiss={onDismiss}
      primaryAction={
        <Banner.PrimaryAction as="a" href={PROJECTS_DOCS_URL} target="_blank" rel="noopener noreferrer">
          Learn more
          <VisuallyHidden>&nbsp;(opens in a new tab)</VisuallyHidden>
        </Banner.PrimaryAction>
      }
    />
  )
}
